var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',_vm._b({key:_vm.color,class:_vm.size,style:(_vm.style)},'i',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }